export default "__VITE_ASSET__CI$clzq7__"